module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dir_layer_off-6c8dfcf6bec71cccb1b3da6c9ec015c5.jpg";